import React  from "react";

// styles
import * as Styled from './styles';
import { FloatingButton } from '../styles';

function BoxOver({ messages, setState }) {
    return (
        <Styled.BoxContainer >
            <Styled.Box>
                <h3> { messages.title } </h3>
                <hr/>
                <ul>
                {
                    messages.rules.map(rule => {
                        return <li>
                            { rule[0] }
                            {rule[1].length > 0 &&
                            <ul>{
                                rule[1].map( subRule => {
                                    return (
                                        subRule.includes('Wrong:') ?
                                        <li className="sub wrong">{ subRule }</li> :
                                        subRule.includes('Right:') ?
                                        <li className="sub right">{ subRule }</li> :
                                        <li>{ subRule }</li>
                                    )
                                })
                            }</ul>}
                        </li>
                    })
                }
                </ul>
            
                <FloatingButton 
                    buttonType="info"
                    onClick={ () => setState(false) } 
                >
                    x
                </FloatingButton>
            </Styled.Box>
        </Styled.BoxContainer>
    );
}

export default BoxOver;
